// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Providers } from "@microsoft/mgt-element";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";
import './index.css';
Providers.globalProvider = new Msal2Provider({
  clientId: 'f8ffa801-4095-40dd-905e-7df08a409b3e',
  authority: "https://login.microsoftonline.com/d1914b7e-ab97-42ac-8cc3-5c95b32a8a08", // Your tenant ID
  redirectUri: "http://localhost:3000" // Your redirect URI
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
            <App />
    </React.StrictMode>
);
